import {MenuClickEvent} from "../../../core/models/events/menu.click-event";

export class CompetitionsSliderMenuClickEvent extends MenuClickEvent {}
